class CheckActive {

    static check = to => (match, location) => location.pathname.includes(to)

}

export default CheckActive;